// Dictionary Entry Limits
export const MAX_ACKNOWLEDGEMENTS = 10
export const MAX_AUDIO = 10
export const MAX_CATEGORIES = 10
export const MAX_DOCUMENTS = 10
export const MAX_IMAGES = 10
export const MAX_NOTES = 10
export const MAX_PRONUNCIATIONS = 3
export const MAX_RELATED_ENTRIES = 10
export const MAX_SPELLINGS = 3
export const MAX_TRANSLATIONS = 10
export const MAX_VIDEOS = 10

// Other
export const MAX_AUDIO_BASIC = 3 // Characters, Story Covers, and Story Pages
export const MAX_GALLERY_ITEMS = 40
export const MAX_LYRICS = 25
